import { render, staticRenderFns } from "./GameMode.vue?vue&type=template&id=57ef1821&scoped=true&"
import script from "./GameMode.vue?vue&type=script&lang=js&"
export * from "./GameMode.vue?vue&type=script&lang=js&"
import style0 from "./GameMode.vue?vue&type=style&index=0&id=57ef1821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef1821",
  null
  
)

export default component.exports